import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  setLocalData<T>(key: string, value: T) {
    if (localStorage.getItem(key)) {
      localStorage.removeItem(key);
    }
    localStorage.setItem(key, JSON.stringify(value));
  }
  setLocalDataStr(key: string, value: string) {
    if (localStorage.getItem(key)) {
      localStorage.removeItem(key);
    }
    localStorage.setItem(key, value);
  }
  getLocalData(key: string) {
    if (localStorage.getItem(key)) {
      return JSON.parse(localStorage.getItem(key) || '');
    }
    else {
      return '';
    }
  }
  getLocalDataStr(key: string) {
    return localStorage.getItem(key) || '';
  }
  clearLocalData(valueToRetail:string[]) {
    let valueToRemove: string[] = [];
    
    for (let index = 0; index < localStorage.length; index++) {
      const key = localStorage.key(index);
      if (key != null && valueToRetail.indexOf(key) == -1) {
        valueToRemove.push(key);
      }
    }
    valueToRemove.forEach(element => {
      localStorage.removeItem(element)
    });
  }
}
